import React, {useState} from "react";
import {CustomTooltip, ImageUploadModal} from "../index";
import EditIcon from "@material-ui/icons/Edit";

export const UploadInput = ({
    langTitle,
    langSubTitle,
    langPlaceholder,
    value,
    parameterType,
    onImageUpload,
    disabled,
    fileType,
    previewClassName = "",
}) => {
    const [openUploadImageModal, setOpenUploadImageModal] = useState({
        open: false,
        type: "",
    });

    return (
        <div className="form-group d-flex flex-md-row flex-column justify-content-between align-items-md-center py-4 m-0 border-bottom border-gray">
            <label htmlFor={parameterType}>
                {langTitle}
                <span className="font-size-base text-muted">{langSubTitle}</span>
            </label>
            <div className="d-flex align-items-center" id={parameterType}>
                <div className="d-flex position-relative rounded overflow-hidden border bg-light">
                    <span
                        className={`preview_image ${previewClassName} bg_image_cover`}
                        style={{
                            backgroundImage: `url(${value || "/media/dummy/dummy-img.jpg"})`,
                        }}
                    />
                    <CustomTooltip
                        config={{
                            text: langPlaceholder,
                            placement: "top",
                        }}
                    >
                        <div
                            disabled={disabled}
                            onClick={() => {
                                if (!disabled) {
                                    setOpenUploadImageModal({
                                        open: true,
                                        type: parameterType,
                                    });
                                }
                            }}
                            className="btn btn-icon btn-light position-absolute right-0 bottom-0 edit_button"
                        >
                            <EditIcon />
                        </div>
                    </CustomTooltip>
                </div>
            </div>

            <ImageUploadModal
                fileType={fileType}
                onUpload={onImageUpload}
                open={openUploadImageModal}
                setOpen={setOpenUploadImageModal}
                placeholder={value}
            />
        </div>
    );
};
